import {
  CUSTOMER_GIFT_CARD_LIST_REQUESTING,
  GET_CUSTOMER_GIFT_CARD_SUCCESS,
  CUSTOMER_GIFT_CARD_OBJECT_REQUESTING,
  LIST_CUSTOMER_GIFT_CARD_SUCCESS,
  RESET_CUSTOMER_GIFT_CARD_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  isListFetching: false,
  isObjectFetching: false,
  query: null,
  recordCount: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CUSTOMER_GIFT_CARD_ISFETCHING: {
      return {
        ...state,
        isListFetching: false,
        isObjectFetching: false
      };
    }
    case CUSTOMER_GIFT_CARD_LIST_REQUESTING: {
      return {
        ...state,
        isListFetching: true
      };
    }
    case CUSTOMER_GIFT_CARD_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }
    case LIST_CUSTOMER_GIFT_CARD_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.data.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        ...state,
        data,
        query,
        recordCount: action.payload.total,
        isListFetching: false
      };
    }
    case GET_CUSTOMER_GIFT_CARD_SUCCESS: {
      const data = { ...state.data };
      const query = [...state.query];
      data[action.payload.id] = action.payload;
      if (!query.includes(action.payload.id)) {
        query.push(action.payload.id);
      }
      return {
        ...state,
        data,
        query,
        isObjectFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
